
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import Button from "../../components/shared/button/Btn"
import FirmaSearchInput from "../../components/shared/firmalarim/FirmaSearchInput"
import { showModal } from "../../features/modal/modalSlice"
import FirmalarimContainer from "../../components/devamlıAraclarContainers/FirmalarimContainer"
import { firmalarimGet } from "../../features/firma/FirmaSlice"

const Container = styled.div`

width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            color: ${({ theme }) => theme.mainTextColor};
            .top-container{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 30px;
            }
        }

        .pagination-container{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            height: 200px;
        }
    }
`
    
const Teklifler = () => {
    const dispatch = useDispatch()
    const {firmaSearch, companyList} = useSelector((state) => state.firma)
    
    useEffect(()=>{
        dispatch(firmalarimGet(firmaSearch))
    },[firmaSearch])

  return (
    <Container>
        <div className="wrapper">
            <PageTopTitle title={"Firmalarım"} position="sticky"/>
            <div className="content">
                <div className="top-container">
                    <div className="search">
                        <FirmaSearchInput data={firmaSearch} name="firmaSearch" labelText="Firma Adı" type="text" />
                    </div>
                    <div className="btn">
                        <Button handleClick={() => dispatch(showModal("firmalarFirmaEkleModal"))} color="#E85446" padding="10px" >Firma Ekle</Button>
                    </div>
                </div>
                
                {companyList?.map((item)=>(
                    <FirmalarimContainer data={item} />
                ))}
            </div>
            
            <div className="pagination-container">
           
            </div>
        </div>
    </Container>
  )
}

export default Teklifler